import { createContext } from 'react';

import type { CreatePanel, PanelContext } from './types';

export function createPanel(): CreatePanel {
	const Context = createContext<PanelContext>({
		setPanel: () => {},
	});

	return {
		Context,
	};
}
